var map = {
	"./en/utcom.json": 1194,
	"./ru/utcom.json": 1195
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1193;


//////////////////
// WEBPACK FOOTER
// ./locales ^\.\/.*\/utcom\.json$
// module id = 1193
// module chunks = 118